// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__31rnA","description":"PatientConsentPreview_description__jedmQ"};